import { useEffect, useRef, useState } from "react";
import { ChevronDown, X } from "lucide-react";
import {
  FilterSelectWrapper,
  FilterSelectTrigger,
  FilterSelectMenu,
  FilterCheckboxOption,
  StatusChipSummary,
  StatusSummaryChip,
  StatusSummaryMore,
  WarehouseSearchInput,
  WarehouseOptionsList,
} from "./styles.tableWithFilters";

/** Multi-select dropdown for filter cards. options: [{ value, label }], selected: value[] */
export default function FilterMultiSelect({ options, selected, onToggle, placeholder = "Select", searchable = false }) {
  const [isOpen, setIsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return undefined;
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  const firstSelected = selected.length > 0
    ? options.find((o) => o.value === selected[0])
    : null;
  const firstSelectedLabel = firstSelected ? firstSelected.label : selected[0] || "";

  const filteredOptions = searchable
    ? options.filter((o) => o.label.toLowerCase().includes(searchQuery.toLowerCase()))
    : options;

  return (
    <FilterSelectWrapper ref={wrapperRef}>
      <FilterSelectTrigger type="button" aria-haspopup="listbox" aria-expanded={isOpen} onClick={() => setIsOpen((open) => !open)}>
        {selected.length > 0 ? (
          <StatusChipSummary>
            <StatusSummaryChip>
              {firstSelectedLabel}
              <X
                size={12}
                onClick={(event) => {
                  event.stopPropagation();
                  onToggle(selected[0]);
                }}
              />
            </StatusSummaryChip>
            {selected.length > 1 && <StatusSummaryMore>& {selected.length - 1} more</StatusSummaryMore>}
          </StatusChipSummary>
        ) : (
          <span>{placeholder}</span>
        )}
        <ChevronDown size={16} />
      </FilterSelectTrigger>
      {isOpen && (
        <FilterSelectMenu role="listbox" aria-multiselectable="true">
          {searchable && (
            <WarehouseSearchInput
              type="text"
              placeholder="Search..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onClick={(e) => e.stopPropagation()}
            />
          )}
          <WarehouseOptionsList>
            {filteredOptions.map((option) => (
              <FilterCheckboxOption key={option.value}>
                <input type="checkbox" checked={selected.includes(option.value)} onChange={() => onToggle(option.value)} />
                {option.label}
              </FilterCheckboxOption>
            ))}
          </WarehouseOptionsList>
        </FilterSelectMenu>
      )}
    </FilterSelectWrapper>
  );
}
